export default __webpack_public_path__ + "static/lifehouse-32491943e14c93ba2e0d4034ce60e98a.svg";